var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mapDiv",
      staticStyle: { height: "100%", position: "relative" },
    },
    [
      _c("div", { staticClass: "map", attrs: { id: "map" } }),
      _vm.showDt && JSON.stringify(_vm.poisiton) !== "{}"
        ? _c("c-detail", {
            ref: "detailTask",
            staticClass: "detail",
            attrs: { form: _vm.poisiton },
          })
        : _vm._e(),
      _vm.showFpxmDt && JSON.stringify(_vm.fPoisiton) !== "{}"
        ? _c("f-detail", {
            ref: "fpDetailTask",
            staticClass: "detail",
            attrs: { form: _vm.fPoisiton },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }